// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/report-templates?societaId=',
    requestBody: null,
    response: '{"success":true,"data":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-logs?societaId=&templateId=&tipoAzione=&esito=&from=&to=',
    requestBody: null,
    response: '{"success":true,"data":[...]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
